import React from "react";

const ChevronDown = () => {
  return (
    <>
      <svg
        width="20"
        height="20"
        fill="none"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="m6 9 6 6 6-6"></path>
      </svg>
    </>
  );
};

export default ChevronDown;
